import { Star } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "karthik kotha",
      role: "Resident",
      rating: 5,
      date: "7 months ago",
      text: "The view from my apartment is very very nice. There is a pool, squash court, tennis court, cricket court, pool table, carom board, indoor gym and outdoor gym for kids, basketball court, maze for kids, football court, and actually 2 parks - one up and one down. Everything is well-maintained and the amenities are exceptional.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/4L1wabcdfuVBYSu79",
      initials: "KK",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/MzoZCTYVRmLlUdFZ.jpg"
    },
    {
      name: "HASSAN SHARIFF",
      role: "Resident",
      rating: 5,
      date: "2 years ago",
      text: "Amazing apartment on OMR. Has all the indoor and outdoor amenities. Worth to stay here. It's very safe with excellent security staff and ample of open spaces. Has all the shops including cafe, bakery, clinic, tailor, ironing, convenience store etc. Very safe for children. Power and water is available 24/7 all 365 days a year.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/YcYQ3TAG2gXdT1jc7",
      initials: "HS",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/phebMqgbVZbaTwSM.jpg"
    },
    {
      name: "Sri Visaeshini",
      role: "Visitor",
      rating: 5,
      date: "3 years ago",
      text: "Purva Swanlake is where my sister resides and I have visited a couple of times to her apartment. Good security system where they follow proper protocols and all time places are neat and tidy. Good job by the staffs who work there. There is gym, swimming pool and park for kids to play and lot more. Overall, a very well-maintained community.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/9z7BzUrQAAQuP5Sr6",
      initials: "SV",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/JDrOORlifrOtMDNk.jpg"
    },
    {
      name: "jagdish sk",
      role: "Resident",
      rating: 5,
      date: "1 month ago",
      text: "One of the best communities in the locality. Well maintained with spacious houses and well built construction compared to the new constructions. Child friendly and ample space for activities. The community management is excellent and the overall living experience is outstanding.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/r354DRPMJQwuAZ6u8",
      initials: "JS",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/FuKSTnRxLmPSnXYI.jpg"
    },
    {
      name: "Sai sivam",
      role: "Resident",
      rating: 5,
      date: "1 month ago",
      text: "Nice apartment with excellent parking area and beautiful gardening spaces. All block parking available. Security checking is proper and professional. The overall infrastructure and maintenance standards are very good.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/9XuUQMmquAUVSxE69",
      initials: "SS",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/uqLbPOmxAIdHKBvN.jpg"
    },
    {
      name: "maddy karthik",
      role: "Visitor",
      rating: 5,
      date: "3 years ago",
      text: "Excellent enclave that is neatly maintained with complete security protection at the entry. Rehabilitation and park facilities are available at the back of the high-rise buildings. Medical facilities and supermarket are conveniently located inside the complex. Water supply is reliable and the overall infrastructure is well-planned.",
      source: "Google Review",
      reviewUrl: "https://maps.app.goo.gl/gX4MU9nQQDSKm4nC6",
      initials: "MK",
      image: "https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/mKBCRqknQCEyMifl.jpg"
    }
  ];

  return (
    <section id="testimonials" className="py-20 sm:py-32 bg-gradient-to-b from-slate-50 via-white to-slate-50">
      <div className="section-container">
        <div className="mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Resident Testimonials
          </h2>
          <p className="text-xl text-slate-600 font-light max-w-3xl">
            Real experiences from our community members
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:border-blue-400 hover:scale-105 hover:-translate-y-2 flex flex-col"
            >
              {/* Profile Section at Top */}
              <div className="bg-gradient-to-r from-blue-50 to-slate-50 p-6 border-b border-slate-200">
                <div className="flex items-center gap-4">
                  {/* Profile Photo */}
                  <div className="w-16 h-16 rounded-full flex-shrink-0 shadow-md border-2 border-blue-300 overflow-hidden bg-gradient-to-br from-blue-400 to-blue-600">
                    {testimonial.image ? (
                      <img
                        src={testimonial.image}
                        alt={`${testimonial.name}'s profile photo`}
                        className="w-full h-full object-cover"
                        loading="lazy"
                        onError={(e) => {
                          // Fallback to initials if image fails to load
                          const target = e.currentTarget;
                          target.style.display = 'none';
                          const parent = target.parentElement;
                          if (parent) {
                            parent.classList.add('flex', 'items-center', 'justify-center');
                            const span = document.createElement('span');
                            span.className = 'text-white font-bold text-lg';
                            span.textContent = testimonial.initials;
                            parent.appendChild(span);
                          }
                        }}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-white font-bold text-lg">
                        {testimonial.initials}
                      </div>
                    )}
                  </div>
                  {/* Name and Role */}
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-slate-900 text-lg leading-tight break-words">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-slate-600 font-medium mt-1">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>

              {/* Stars */}
              <div className="px-6 pt-6 flex gap-1">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>

              {/* Review Text */}
              <div className="px-6 py-4 flex-grow">
                <p className="text-slate-700 leading-relaxed italic">
                  "{testimonial.text}"
                </p>
              </div>

              {/* Footer with Date and Link */}
              <div className="px-6 py-6 border-t border-slate-200 flex items-center justify-between gap-4">
                <p className="text-xs text-slate-500 font-medium">
                  {testimonial.date}
                </p>
                <a
                  href={testimonial.reviewUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs font-semibold text-blue-600 bg-blue-100 hover:bg-blue-200 px-3 py-1 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {testimonial.source} →
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Overall Rating */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-slate-50 border border-blue-200 rounded-xl p-8 text-center">
          <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
            Community Rating
          </p>
          <div className="flex items-center justify-center gap-3 mb-3">
            <span className="text-5xl font-bold text-slate-900">4.4</span>
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className={`w-6 h-6 ${
                    i < 4 ? "fill-yellow-400 text-yellow-400" : "fill-slate-300 text-slate-300"
                  }`}
                />
              ))}
            </div>
          </div>
          <p className="text-slate-600">Based on 455+ reviews on Google Maps</p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
